<template>
  <div class="history">
    <div class="history-content" @scroll="scrollHandler">
      <div class="history-line" v-for="item in historyList" :key="item.id" @click="toResult(item)">
        <div class="history-header">
          <div class="name">AI急重症预警套餐</div>
          <div class="status danger" v-if="item.used">未完成</div>
          <div class="status success" v-else>已完成</div>
        </div>
        <div class="history-dis">
          <div class="dis-name">
            <div class="name" v-for="d in disArr.filter(cD => item.dis.includes(cD.id))" :key="d.id">
              {{ d.name }}
            </div>
          </div>
          <div class="dis-total">共 {{ disArr.filter(cD => item.dis.includes(cD.id)).length }} 種風險</div>
        </div>
        <div class="history-footer">
          <div class="time">{{ item.created_at }}</div>
          <div class="btn">
            <div class="btn-cancel" v-if="item.cancel" @click="showCancel(item)">取消</div>
            <div class="btn-confirm" @click="toQuestion(item)" v-if="item.used">去使用</div>
            <div v-else></div>
          </div>
        </div>
      </div>
      <div class="no-history" v-if="historyList.length === 0">
        <img class="medin-icon" src="../../assets/images/history/medin-icon.png" alt="">
        <div class="tip">暫時還沒有歷史評估記錄哦~</div>
      </div>
    </div>
    <div class="history-footer-action">
      <div @click="buyPackage">點擊訂購AI智慧健康自測</div>
    </div>
    <van-popup class="question-mention-popup" v-model="showQuestionMention" position="center">
      <div class="question-mention-container">
        <div class="question-mention-title">溫馨提示</div>
        <ul>
          <li>你需要提供身體指標，例如身高、體重、腰圍、臀圍，建議即時測量以保證數據精准；</li>
          <li>同時還需要提供生化指標，包括：空腹血糖Glucose(Fasting)，糖化血色素HbA1c，總膽固醇Cholesterol
            Total，高密度膽固醇HDL-Cholesterol，低密度膽固醇LDL-Cholesterol，三酸甘油酯Triglycerides，尿酸Uric Acid；
          </li>
          <li>你需要提供以上7項生化指標中的<span class="red">至少一項</span>，提供的指標愈多，AI分析結果愈精准；
          </li>
          <li>你可以通過家用設備如血糖儀即時測量，也可翻閱最近1年的健檢報告獲取相關指標。</li>
        </ul>
        <div class="question-mention-btn" @click="jump">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Image, Grid, GridItem, Tabbar, TabbarItem, Button, ImagePreview, Popup, Toast, Dialog } from 'vant'
Vue.use(NavBar)
  .use(Image)
  .use(Grid)
  .use(GridItem)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Button)
  .use(Toast)
  .use(ImagePreview)
  .use(Popup);

import { listMyLink, cancelPackage, getUserHasUse } from '@/js/axios.js'
import { Base64 } from 'js-base64'


export default {
  name: 'userHistory',
  data () {
    return {
      pager: {
        page: 1,//當前頁，默認第0頁
        pagesize: 20,//每頁多少條數據 默認10
        act: ''
      },
      lists: [],//歷史列表數據
      loading: false,//是否處於加載狀態
      finished: false,//是否加載完成
      historyList: [],
      total: 0,
      isScrollLoadOpen: false,
      showQuestionMention: false,
      disArr: [
        {
          id: "A05",
          name: '痛風風險',
          price: 900,
          lastPrice: 3888,
          disabled: false
        },
        {
          id: "A03",
          name: '心肌梗塞風險',
          price: 900,
          lastPrice: 3888,
          disabled: false
        },
        {
          id: 'A17',
          name: '腦中風風險',
          price: 900,
          lastPrice: 3888,
          disabled: false
        },
        {
          id: "A07",
          name: '癌症風險',
          price: 900,
          lastPrice: 3888,
          disabled: false
        },
      ],
      cancelPackageId: "",
      isConfirmShow: false,
      order_id: ""
    }
  },
  computed: {

  },
  created () {
    this.getHistoryData()
  },
  mounted () {

  },
  beforeDestroy () {

  },
  methods: {
    async getHistoryData () {

      const result = await listMyLink(this.pager)
      if (result.code === 200) {

        const data = JSON.parse(Base64.decode(result.data))
        console.log("data", data);

        this.historyList = data.data
        this.total = Number(data.pager.count)
        // console.log("data", data);

        if (this.total > this.pager.pagesize) {
          this.isScrollLoadOpen = true
        } else {
          this.isScrollLoadOpen = false
        }
      }
    },
    scrollHandler (e) {
      const { scrollHeight, scrollTop, offsetHeight } = e.target
      if (this.isScrollLoadOpen) {
        if (scrollTop + offsetHeight >= scrollHeight - 30) {
          this.isScrollLoadOpen = false
          this.pager.pagesize = this.pager.pagesize + 20
          this.getHistoryData()
        }
      }
    },
    toResult (item) {
      if (!item.used) {
        this.$router.push(`/result/${item.id}`)
      }
    },
    toQuestion (item) {
      this.showQuestionMention = true
      this.order_id = item.id

    },
    buyPackage () {
      this.showQuestionMention = true
      this.order_id = ""
    },
    jump () {
      if (this.order_id) {
        this.$router.push({
          path: '/question/four',
          query: {
            order_id: this.order_id
          }
        })
      } else {
        this.$router.push('/pay')
      }

    },

    showCancel (item) {
      Dialog.confirm({
        title: '确定取消？',
        message: '取消订单后无法恢复，积分将原路返还',
        confirmButtonText: '確定',
        cancelButtonText: '放弃',
      }).then(() => {
        this.cancelPackageId = item.id
        console.log("cancelPackageId", this.cancelPackageId);
        this.cancel(item.id)
      }).catch(() => {
        console.log('取消')
      })
    },
    async cancel (id) {
      const data = {
        order_id: id
      }
      const result = await cancelPackage(data)
      if (result.code === 200) {
        this.isConfirmShow = false
        this.$toast.success('取消成功')
        this.checkUserUse()
        this.getHistoryData()
      } else {
        this.$toast.fail(result.msg)
      }
    },
    async checkUserUse () {
      const res = await getUserHasUse()
      if (res.code == 200) {
        const data = JSON.parse(Base64.decode(res.data))
        const { firstUse, firstFree } = data
        console.log(firstUse, firstFree)
        if (firstUse) {
          this.$store.commit('changeFirstUse', firstUse)
        } else {
          this.$store.commit('changeFirstUse', 0)
        }
        if (firstFree) {
          this.$store.commit('changeFirstFree', firstFree)
        } else {
          this.$store.commit('changeFirstFree', 0)
        }
      }
    }
  }
}
</script>


<style>
.van-popup {
  background-color: transparent !important;
  overflow: visible !important;
}
</style>

<style lang="scss" scoped>
.history {
  position: relative;
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr auto;
  font-size: .28rem;
  overflow: hidden;
  background-color: #F5F8FC;
  color: #fff;

  .history-content {
    position: relative;
    width: 100%;
    flex: 1;
    padding: .24rem;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .no-history {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .medin-icon {
        width: 3.4rem;
      }

      .tip {
        margin: .56rem 0;
        color: #222222;
      }

      .no-history-btn {
        padding: .08rem .32rem;
        border-radius: .04rem;
        border: .02rem solid #fff;
      }
    }


    .history-line {
      position: relative;
      background-color: #fff;
      margin-bottom: .24rem;
      padding: .24rem;
      border-radius: .12rem;
      color: #333;

      >div {
        white-space: nowrap;
        width: 100%;
      }

      .history-header {

        display: flex;
        align-items: center;
        justify-content: space-between;

        .name {
          font-size: .32rem;
          overflow: hidden;
          margin-right: 12px;
          display: flex;
          align-items: center;
          font-weight: bold;

          &::before {
            content: "";
            display: block;
            width: 0.32rem;
            height: 0.32rem;
            background-image: url("../../assets/images/history/dis-name.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 0.12rem;
          }
        }

        .status {

          font-weight: 600;
          font-size: 0.24rem;
          line-height: 0.32rem;
          text-align: right;
          font-style: normal;
        }

        .danger {
          color: #F80000;

        }

        .success {
          color: #00B050;
        }
      }

      .history-dis {
        position: relative;
        text-align: left;
        padding: 0.2rem 0.4rem;
        font-weight: 400;
        font-size: 0.26rem;
        color: #999999;
        line-height: 0.36rem;
        text-align: justify;
        font-style: normal;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      .history-footer {
        padding-top: .18rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px dotted #00000010;
        color: #999;

        .btn {
          display: flex;
          align-items: center;

          .btn-cancel {
            color: #00000090;
            padding: 0.12rem 0.32rem;
            border-radius: 0.28rem;
            border: 1px solid #00000030;
            margin-right: 0.24rem;
          }

          .btn-confirm {
            background: #6681FA;
            border-radius: 0.28rem;
            padding: 0.12rem 0.42rem;
            color: #fff;
          }
        }


      }

    }
  }

  .history-footer-action {
    padding: .24rem;

    >div {
      background-color: #6681FA;
      padding: .2rem;
      border-radius: 1rem;
    }
  }
}
</style>